export default __webpack_public_path__ + "static/media/best.5e6b5277.png";